export default __webpack_public_path__ + "f57f59e2af716df782d203bad1ba9b0d.png";